var _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 11.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 11.5,
    stroke: "#BABABA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 21.0667C15 19.1811 16.5144 17.6667 18.4 17.6667H37.6C39.4856 17.6667 41 19.1811 41 21.0667C41 22.2217 40.414 23.1167 39.8475 23.8248C39.7833 23.9051 39.707 23.9751 39.6214 24.0321L31.6075 29.3747C29.4114 30.7865 26.722 30.7864 24.5259 29.3746L24.5025 29.3591L16.5025 23.8924C16.4818 23.8782 16.4616 23.8633 16.442 23.8476C15.605 23.178 15 22.247 15 21.0667ZM18.4 19.6667C17.619 19.6667 17 20.2857 17 21.0667C17 21.4788 17.1879 21.8739 17.6641 22.2638L25.6187 27.6995C27.1515 28.679 28.9871 28.6781 30.5192 27.6965L38.3791 22.4566C38.8127 21.8935 39 21.483 39 21.0667C39 20.2857 38.3811 19.6667 37.6 19.6667H18.4Z",
    fill: "#353535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.3334C16.5523 20.3334 17 20.7812 17 21.3334V34.6668C17 35.5812 17.7523 36.3334 18.6667 36.3334H37.3333C38.2477 36.3334 39 35.5812 39 34.6668V21.3334C39 20.7812 39.4477 20.3334 40 20.3334C40.5523 20.3334 41 20.7812 41 21.3334V34.6668C41 36.6857 39.3523 38.3334 37.3333 38.3334H18.6667C16.6477 38.3334 15 36.6857 15 34.6668V21.3334C15 20.7812 15.4477 20.3334 16 20.3334Z",
    fill: "#353535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6165 27.717C26.007 28.1075 26.007 28.7407 25.6165 29.1312L17.4912 37.2565C17.1006 37.647 16.4675 37.647 16.077 37.2565C15.6864 36.866 15.6864 36.2328 16.077 35.8423L24.2023 27.717C24.5928 27.3264 25.226 27.3264 25.6165 27.717Z",
    fill: "#353535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4395 27.773C30.83 27.3825 31.4632 27.3825 31.8537 27.773L39.923 35.8423C40.3136 36.2329 40.3136 36.866 39.923 37.2565C39.5325 37.6471 38.8994 37.6471 38.5088 37.2565L30.4395 29.1872C30.049 28.7967 30.049 28.1635 30.4395 27.773Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5b4e0cae7b57f566c22d42e9be92acc9.svg";
export { ForwardRef as ReactComponent };